// -----------Manage-Delivery-Slots-&-Fees-tabs------------
export const ManageDeliverySlotsTabs = [
  { id: 0, name: "Delivery Slot", value: 'DELIVERYSLOTS' },
  { id: 1, name: "Delivery Fees", value: 'DELIVERYFEES' },
  { id: 2, name: "Free Delivery", value: 'FREEDELIVERY' },
]
// ------------Delivery-Slots-&-Fees-tabs------------
export const deliverySlotsTabs = [
  { id: 0, name: "Delivery", value: 'DELIVERY' },
  { id: 1, name: "Pickup", value: 'PICKUP' },
]
// -----------------Coins-Management-tabs---------------------
export const coinTabs = [
  { id: 0, name: "Set Coin Value", value: 'SETCOINVALUE' },
  { id: 1, name: "Award  Coins ", value: 'AWARDCOINS' },
]
// -----------------order-Management-view---------------------
export const deliveryStatusValue = [
  { _id: "ACCEPTED", name: "Accepted" },
  { _id: "PROCESSING", name: "Processing" },
  { _id: "OUT_FOR_DELIVERY", name: "Out for Delivery" },
  { _id: "DELIVERED", name: "Delivered" },
  { _id: "CANCELLED", name: "Cancelled" },
];
